import { useTranslation } from 'react-i18next';
import { AnimatedSection } from '../../../components/AnimatedSection';

export default function ContactInfo() {
  const { t } = useTranslation();

  return (
    <AnimatedSection animation="slide-left">
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold text-white mb-2">{t('contact_info_title')}</h2>
          <p className="text-slate-400 text-sm leading-relaxed">
            {t('contact_info_desc')}
          </p>
        </div>

        <div className="space-y-4">
          <a
            href="mailto:info@absystemthai.com"
            className="flex items-start gap-4 bg-slate-800/50 border border-slate-700 hover:border-cyan-500/40 rounded-xl p-5 transition-all cursor-pointer group"
          >
            <div className="w-10 h-10 flex items-center justify-center bg-cyan-500/10 rounded-lg shrink-0">
              <i className="ri-mail-line text-cyan-400 text-xl"></i>
            </div>
            <div>
              <div className="text-white font-semibold text-sm">{t('contact_email_label')}</div>
              <div className="text-slate-500 text-xs mb-1">{t('contact_email_sub')}</div>
              <div className="text-cyan-400 text-sm group-hover:text-cyan-300 transition-colors">info@absystemthai.com</div>
            </div>
          </a>
        </div>

        {/* Emergency Support */}
        <div className="bg-emerald-500/5 border border-emerald-500/20 rounded-xl p-5">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></div>
            <span className="text-emerald-400 text-sm font-semibold">{t('contact_emergency_title')}</span>
          </div>
          <p className="text-slate-400 text-xs leading-relaxed mb-3">
            {t('contact_emergency_desc')}
          </p>
        </div>

        {/* Certifications */}
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-5">
          <p className="text-slate-400 text-xs font-semibold uppercase tracking-wider mb-4">{t('contact_partners_label')}</p>
          <div className="flex flex-wrap gap-3">
            {['Fortinet', 'Palo Alto', 'Cisco', 'Microsoft', 'AWS'].map(brand => (
              <span key={brand} className="text-xs px-3 py-1.5 bg-slate-700 text-slate-300 rounded-lg font-medium">{brand}</span>
            ))}
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
}
